import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile vs desktop device mode and handle user manual overrides
 */
export function useDeviceMode() {
  const [viewMode, setViewMode] = useState(() => {
    return localStorage.getItem('clou_view_mode') || 'auto'; // 'auto' | 'mobile' | 'desktop'
  });

  const [isScreenMobile, setIsScreenMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    const isMobileUA = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return isMobileUA || window.innerWidth < 768;
  });

  useEffect(() => {
    const handleResize = () => {
      const isMobileUA = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsScreenMobile(isMobileUA || window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const setManualViewMode = (mode) => {
    setViewMode(mode);
    localStorage.setItem('clou_view_mode', mode);
  };

  // Determine if active UI should be mobile
  const isMobile = viewMode === 'mobile' || (viewMode === 'auto' && isScreenMobile);

  return {
    isMobile,
    viewMode,
    setManualViewMode,
    isScreenMobile
  };
}
